// Module
var code = `<div> <component-transfer-field></component-transfer-field> <div class="contacts-list" id="contacts-list"></div> </div> `;
// Exports
export default code;